module.exports = __webpack_public_path__ + "public/images/icons/book.c959073ecb686bd1c83aa9dd9357cbe6.png";